import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'country',
  pure: true
})
export class CountryPipe implements PipeTransform {
  transform(isoCode?: string, locale: string = 'fr'): string {
    if (!isoCode) return '';

    try {
      const displayNames = new Intl.DisplayNames([locale], { type: 'region' });
      return displayNames.of(isoCode.toUpperCase()) || 'Pays inconnu';
    } catch (e) {
      return 'Pays inconnu';
    }
  }
}
